import { stopEvent } from '@/utils/tools'
import { Select, SelectProps } from '@gate/gui'
import { Flex } from '@mantine/core'
import { useTranslation } from 'next-i18next'
import { FC } from 'react'

const TitleSelect: FC<Omit<SelectProps, 'data'>> = ({ ...props }) => {
  const { t } = useTranslation()

  return (
    <Flex w={85} onClick={stopEvent} mr={2}>
      <Select
        size="xs"
        data={[
          {
            label: t('P.timeH', { time: 1 }) as string,
            value: '1h',
          },
          {
            label: t('P.timeH', { time: 4 }) as string,
            value: '4h',
          },
          {
            label: t('P.timeH', { time: 24 }) as string,
            value: 'utc',
          },
        ]}
        style={{ backgroundColor: 'var(--gui-color-card-2)', overflow: 'hidden' }}
        {...props}
      />
    </Flex>
  )
}

export default TitleSelect
